export const state = {
	message: '',
	type: '',
	status: false
}

export const mutations = {
	TOGGLE_BANNER (state, { status, message = '', type = '' }) {
		state.status = status
		state.message = message || ''
		state.type = type || ''
	}
}

export const actions = {
}

export const getters = {
}

export default {
	state,
	mutations,
	actions,
	getters,
	namespaced: true
}
